import CheckBox from '../formItems/checkBox';
import { MRT_TableInstance } from 'material-react-table';

export interface IGridRowSelectorHeaderProps<T> {
	testId: string;
	table: MRT_TableInstance<T>;
}

const GridRowSelectorHeader = <T extends { id: number }>(props: IGridRowSelectorHeaderProps<T>): React.ReactElement => {
	return (
		<div style={{ textAlign: 'center' }}>
			<CheckBox
				testId={`${props.testId}-selectAll-checkbox`}
				checked={props.table.getIsAllPageRowsSelected()}
				indeterminate={props.table.getIsSomePageRowsSelected()}
				onChange={props.table.toggleAllRowsSelected}
			/>
		</div>
	);
};

export default GridRowSelectorHeader;
